import { useProductRecommendationsQuery as useProductRecommendationsGQLQuery } from '../../../generated/frontend'

interface ProductRecommendationsProps {
  filters?: Record<string, unknown>
  page?: number
  limit?: number
  skip?: boolean
}

export const useProductRecommendationsQuery = ({
  filters,
  page = 1,
  limit = 2,
  skip = false,
}: ProductRecommendationsProps) => {
  const { loading, error, data } = useProductRecommendationsGQLQuery({
    variables: { filters, page, limit },
    skip,
  })

  if (error) {
    console.warn('Error fetching product recommendations:', error)
  }

  const items = data?.productRecommendations?.items ?? []
  const total = data?.productRecommendations?.total ?? 0

  return { loading, error, items, total }
}
